var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRodo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "80.000000pt",
    height: "80.000000pt",
    viewBox: "0 0 80.000000 80.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,80.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 400 l0 -400 400 0 400 0 0 400 0 400 -400 0 -400 0 0 -400z m760 0 l0 -360 -360 0 -360 0 0 360 0 360 360 0 360 0 0 -360z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 400 l0 -270 50 0 50 0 0 115 0 115 41 0 c50 0 70 -19 149 -144 l55 -86 62 0 c35 0 63 3 63 6 0 17 -97 164 -133 202 -34 34 -38 42 -22 42 32 0 83 36 101 71 26 51 15 132 -23 171 -39 39 -83 47 -255 48 l-138 0 0 -270z m298 164 c15 -10 22 -25 22 -49 0 -52 -27 -65 -132 -65 l-88 0 0 65 0 65 88 0 c63 0 94 -4 110 -16z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRodo);
export default __webpack_public_path__ + "static/media/rodo.dd3a3bc728e81371035c32842d706f4c.svg";
export { ForwardRef as ReactComponent };